// This file was generated. All changes will be lost.
// Your changes will be lost.

export class ApiSettings {

	public static ApiUrl : string = "https://az-usw-wmehub-packagesapi-qa.azurewebsites.net/";
	public static AzureAudience : string = "https://imgworld.onmicrosoft.com/cd592221-f9bf-4519-b1d0-94e158a2730e";
	public static AzureAuthority : string = "https://login.microsoftonline.com/9c901a7a-a846-4962-94d8-deb98f963564";
	public static AzureClientId : string = "44d3bacb-7c7a-404f-b5bb-174efbf8c19b";
	public static Environment: string = "QA";
}
